export default "__VITE_ASSET___sqnMS8p__"